import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { IconsModule } from '../icons/icons.module';
import { ToggleSwitchComponent } from './toggle-switch.component';

@NgModule({
  declarations: [ToggleSwitchComponent],
  imports: [FormsModule, CommonModule, IconsModule],
  exports: [ToggleSwitchComponent],
})
export class ToggleSwitchModule {}
